import { View } from 'react-native';
import { UnboaredActivityIndicator } from '@unboared/design.all';

export const UnboaredPageLoader = ({ infos }: { infos: string }) => (
  <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center' }}>
    <UnboaredActivityIndicator infos={infos} size={100} />
  </View>
);
